import api from './api'

/**
 * Serviço de Billing (Financeiro)
 * Gerencia faturas, resumo financeiro e pagamentos do tenant.
 */
export default {
  /**
   * Obter resumo financeiro do tenant
   * GET /api/tenant/billing/summary
   * 
   * Retorna: usuáriosAtivos, custoUsuario, faturaAtual, crescimento
   */
  getResumo() {
    return api.get('/api/tenant/billing/summary')
  },

  /**
   * Obter fatura atual detalhada
   * GET /api/tenant/billing/current-invoice
   * 
   * Retorna: itens, subtotal, desconto, total, vencimento, status
   */
  getFaturaAtual() {
    return api.get('/api/tenant/billing/current-invoice')
  },

  /**
   * Obter histórico de faturas
   * GET /api/tenant/billing/invoices
   * @param {Object} params - { page, size, status }
   */
  getHistoricoFaturas(params = {}) {
    return api.get('/api/tenant/billing/invoices', { params })
  },

  /**
   * Obter fatura por ID
   * GET /api/tenant/billing/invoices/:id
   * @param {string} faturaId
   */
  getFaturaById(faturaId) {
    return api.get(`/api/tenant/billing/invoices/${faturaId}`)
  },

  /**
   * Baixar PDF da fatura
   * GET /api/tenant/billing/invoices/:id/pdf
   * @param {string} faturaId
   */
  downloadPDF(faturaId) {
    return api.get(`/api/tenant/billing/invoices/${faturaId}/pdf`, {
      responseType: 'blob'
    })
  },

  /**
   * Processar pagamento de fatura
   * POST /api/tenant/billing/invoices/:id/pay
   * @param {string} faturaId
   * @param {Object} paymentData - { metodo: 'PIX'|'BOLETO'|'CARTAO' }
   */
  pagarFatura(faturaId, paymentData = {}) {
    return api.post(`/api/tenant/billing/invoices/${faturaId}/pay`, paymentData)
  },

  /**
   * Atualizar forma de pagamento padrão
   * PUT /api/tenant/billing/payment-method
   * @param {Object} data - { metodo, dados }
   */
  atualizarFormaPagamento(data) {
    return api.put('/api/tenant/billing/payment-method', data)
  }
}
